export const getCurrentRoute = state => {
  if (!state) {
    return "Home";
  }
  return state.routeNames[state.index];
};

interface GetTabNotificationsProps {
  tabName: string;
  isActive: boolean;
  newMessageNotifications: number;
  newHomeNotifications: number;
  newGeneralNotifications: number;
  newResourceNotifications: number;
}

export const getTabNotifications = ({
  tabName,
  isActive,
  newMessageNotifications = 0,
  newHomeNotifications = 0,
  newGeneralNotifications = 0,
  newResourceNotifications = 0,
}: GetTabNotificationsProps): number => {
  if (isActive) return 0;

  switch (tabName) {
    case "Message":
      return newMessageNotifications;
    case "Home":
      return newHomeNotifications;
    case "Notification":
      return newGeneralNotifications + newMessageNotifications;
    case "Library":
      return newResourceNotifications;
    default:
      return 0;
  }
};
